import { useState, useEffect } from 'react';
import { sectionStyles } from '../utils';

export default function SocialProofLiveSection({ block = {}, primaryColor, secondaryColor }) {
    const { config = {}, content = {} } = block;
    const s = sectionStyles(config, primaryColor, secondaryColor);

    const items = content.items || [
        { name: 'Maria', city: 'Madrid', action: 'se registro', time: 'hace 2 min' },
        { name: 'Carlos', city: 'Buenos Aires', action: 'compro el plan Pro', time: 'hace 5 min' },
        { name: 'Ana', city: 'Lima', action: 'descargo la guia', time: 'hace 8 min' },
    ];

    const position = config.position || 'bottom-left';
    const interval = (config.interval || 5) * 1000;
    const duration = (config.display_duration || 4) * 1000;

    const [current, setCurrent] = useState(0);
    const [visible, setVisible] = useState(false);
    const [initialDelay, setInitialDelay] = useState(true);

    useEffect(() => {
        const startTimer = setTimeout(() => {
            setInitialDelay(false);
            setVisible(true);
        }, (config.initial_delay || 3) * 1000);
        return () => clearTimeout(startTimer);
    }, []);

    useEffect(() => {
        if (initialDelay || items.length === 0) return;
        let showTimeout;
        let hideTimeout;
        const cycle = () => {
            showTimeout = setTimeout(() => {
                setCurrent(c => (c + 1) % items.length);
                setVisible(true);
                hideTimeout = setTimeout(() => {
                    setVisible(false);
                }, duration);
            }, interval);
        };
        // Hide current after duration, then schedule next
        hideTimeout = setTimeout(() => {
            setVisible(false);
            cycle();
        }, duration);
        return () => { clearTimeout(showTimeout); clearTimeout(hideTimeout); };
    }, [initialDelay, current, items.length, interval, duration]);

    if (items.length === 0) return null;

    const item = items[current % items.length];
    const posClass = position === 'bottom-right' ? 'bottom-4 right-4'
        : position === 'top-left' ? 'top-4 left-4'
        : position === 'top-right' ? 'top-4 right-4'
        : 'bottom-4 left-4';

    return (
        <div className={`fixed ${posClass} z-40 transition-all duration-300 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
            <div className="bg-white rounded-xl shadow-2xl border border-gray-100 px-4 py-3 flex items-center gap-3 max-w-xs">
                <div className="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-sm shrink-0" style={{ backgroundColor: primaryColor }}>
                    {item.name?.charAt(0) || '?'}
                </div>
                <div className="min-w-0">
                    <p className="text-sm font-medium text-gray-900 truncate">
                        <span className="font-bold">{item.name}</span> de {item.city}
                    </p>
                    <p className="text-xs text-gray-500">{item.action} · {item.time}</p>
                </div>
            </div>
        </div>
    );
}
